/**
 * @generated SignedSource<<798f063c25799d50efbf86586e0f2f3c>>
 * @relayHash 3c5e3a22621f362bf6dac20b8afe490b
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 4b3000ac3d2928590a6d2fbba5e2df2845ed568bc38f7675686890f9b0fcb2dc

import type { PreloadableConcreteRequest } from 'relay-runtime';
import type { async_AsyncMenuContentQuery } from './async_AsyncMenuContentQuery.graphql';

const node: PreloadableConcreteRequest<async_AsyncMenuContentQuery> = {
  "kind": "PreloadableConcreteRequest",
  "params": {
    "id": "4b3000ac3d2928590a6d2fbba5e2df2845ed568bc38f7675686890f9b0fcb2dc",
    "metadata": {},
    "name": "async_AsyncMenuContentQuery",
    "operationKind": "query",
    "text": null
  }
};

export default node;
